import { Grid, IconButton, Tooltip } from "@mui/material";
import React, { useState } from "react";

import { Tabs } from "@mui/material";
import Tab from "@mui/material/Tab";

import { Add, Close } from "@mui/icons-material";
import { TabPanel } from "app/components/TabPanel";
import { selectRemainingTreatments } from "app/containers/AssignedTreament/redux/selector";
import { actions } from "app/containers/AssignedTreament/redux/slice";
import { AvailableTimeslotsResponse } from "app/containers/AssignedTreament/types";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { selectFeaturePermissions } from "store/global/authPermission/selector";
import { PermissionFeature } from "store/global/authPermission/types";
import { TimeslotActions } from "../Actions";
import { TimeslotInfo } from "../TimeslotInfo";
import { SingleTimeslotSelection } from "./components/SingleTimeslotSelection";
import { useStyles } from "./styles";
type Props = {
  onClose: () => void;
  disable?: boolean;
  availableTimeslotsResponse: AvailableTimeslotsResponse;
  maxTreatmentAmount: number;
  minTreatmentAmount: number;
};
export const TimeslotSingle = ({
  availableTimeslotsResponse,
  disable,
  onClose,
  maxTreatmentAmount,
  minTreatmentAmount,
}: Props) => {
  const styles = useStyles();
  const dispatch = useDispatch();
  const [tab, setTab] = useState(1);
  const remainingTreatments = useSelector(selectRemainingTreatments);

  const handleSave = () => {
    dispatch(actions.setTimeSlot());
  };

  const { t } = useTranslation();

  const handleChange = (e, value: number) => {
    setTab(value);
  };

  const handleAdd = (e) => {
    dispatch(actions.handleAddTreatment());
  };

  const handleRemove = (index) => {
    if (index + 1 == tab) {
      setTab(tab - 1);
    }
    dispatch(actions.handleRemoveTreatment({ index }));
  };
  const featurePermissions = useSelector(selectFeaturePermissions);
  const assigningPermission =
    featurePermissions[PermissionFeature.ASSIGNED_TREATNEMTS_A];
  const schedulingPermission =
    featurePermissions[PermissionFeature.ASSIGNED_TREATNEMTS_B];
  const treatmentInvolvedPatient =
    availableTimeslotsResponse.treatmentInvolvedPatient;
  const timeslotInvolvedPatients =
    treatmentInvolvedPatient.timeslotInvolvedPatients.filter(
      (m) => m.option !== "delete"
    );
  const isDeleteAvailable =
    assigningPermission.hasFullAccess &&
    timeslotInvolvedPatients.length > minTreatmentAmount;
  const isBonus = treatmentInvolvedPatient?.type == "Bonus";

  return (
    <Grid>
      <Grid height={350}>
        <Grid
          display={"flex"}
          flexDirection={"row"}
          alignItems={"center"}
          height={80}
        >
          <Tabs
            value={tab}
            TabIndicatorProps={{ style: { background: "#012397" } }}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons="auto"
            aria-label="scrollable"
          >
            {timeslotInvolvedPatients.map((tip, index) => {
              const assignedTreatment = tip.assignedTreatments?.find(
                (f) => f.timeslotInvolvedPatientId == tip.id
              );
              const isCompleted =
                tip.completedAt ||
                assignedTreatment?.timeslotSession?.completedAt;
              if (tip.option == "delete") {
                return null;
              }
              return (
                <Tab
                  label={t("ASSIGNED_TREATMENT.TREATMENT_NUMBER", {
                    treatment: String(index + 1),
                  })}
                  value={index + 1}
                  iconPosition="end"
                  icon={
                    isDeleteAvailable && !isCompleted ? (
                      <IconButton
                        sx={{ padding: "5px", margin: 0 }}
                        size="small"
                        onClick={() => handleRemove(index)}
                      >
                        <Close sx={{ height: 15, width: 15 }} />
                      </IconButton>
                    ) : undefined
                  }
                />
              );
            })}
          </Tabs>
          {assigningPermission.hasFullAccess && (
            <Tooltip title={t("ASSIGNED_TREATMENT.ADD_TREATMENT_AMOUNT")}>
              <IconButton
                disabled={
                  isBonus ||
                  availableTimeslotsResponse.treatmentInvolvedPatient
                    .timeslotInvolvedPatients.length >= maxTreatmentAmount ||
                  remainingTreatments <= 0
                }
                sx={{ height: 25, width: 25 }}
                onClick={handleAdd}
              >
                <Add sx={{ height: 20, width: 20 }} />
              </IconButton>
            </Tooltip>
          )}
        </Grid>
        {timeslotInvolvedPatients.map((timeslotInvolvedPatient, index) => {
          return (
            <TabPanel value={tab} index={index + 1}>
              <Grid xs={12} direction="column">
                <SingleTimeslotSelection
                  index={index}
                  timeslotInvolvedPatient={timeslotInvolvedPatient}
                  availableTimeslotsResponse={availableTimeslotsResponse}
                />
              </Grid>
            </TabPanel>
          );
        })}
        <TimeslotInfo />
      </Grid>
      <TimeslotActions
        onSave={handleSave}
        onClose={onClose}
        disable={disable}
        isLoading={disable}
      />
    </Grid>
  );
};
